<template>
  <div class="pb-3 candidate profile edit qualification-components">
    <div class="text-xs-right">
      <v-chip slot="activator" style="margin-top: -25px">
        <v-avatar>
          <v-btn
            slot="activator"
            :color="themes.candidate.light.secondaryActionButton"
            @click="createComponent"
            small
            fab
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-avatar>
        Add a subject or module
      </v-chip>
    </div>

    <v-data-table
      :headers="headers"
      :items="qualification.profileQualificationComponents"
      no-data-text="Please add your first subject or module for this qualification"
      hide-actions
    >
      <template slot="items" slot-scope="{ item }">
        <td>{{ item.reference }}</td>
        <td>{{ item.description }}</td>
        <td>
          <div v-if="item.gradeScale && item.gradeValue">
            {{ item.gradeValue }}
            <span class="caption grey--text"> ({{ item.gradeScale }}) </span>
          </div>

          <div v-else-if="qualification.startsAt && new Date(qualification.startsAt) < new Date()">
            <v-chip>
              <v-avatar>
                <v-btn
                  slot="activator"
                  :color="themes.candidate.light.secondaryActionButton"
                  @click.stop="component = item"
                  class="elevation-0"
                  small
                  fab
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-avatar>
              Add results
            </v-chip>
          </div>
          <div v-else>
            No grade required
          </div>
        </td>
        <td class="text-xs-right" style="min-width: 11.5rem;">
          <v-menu
            transition="slide-x-transition"
            :close-on-content-click="false"
            :nudge-width="200"
            nudge-top="10"
            offset-x
            left
          >
            <v-btn small flat fab slot="activator" :color="themes.candidate.light.danger">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-card toolbar>
              <v-toolbar card :color="themes.candidate.light.dialogTitle">
                Are you sure?
                <v-spacer />
                <v-btn
                  @click="deleteComponent(item)"
                  :color="themes.candidate.light.danger"
                  :loading="deletingComponent"
                  dark
                >
                  Delete
                </v-btn>
              </v-toolbar>
            </v-card>
          </v-menu>
          <v-btn
            slot="activator"
            @click="component = item"
            :color="themes.candidate.light.secondaryActionButton"
            small
            flat
            fab
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>

    <v-dialog
      v-if="component"
      @update:returnValue="component = null"
      :value="component"
      max-width="600"
      hide-overlay
      lazy
      attach=".candidate.profile.edit.qualification-components"
    >
      <ComponentForm :value="component" :profile-qualification="qualification" @close="reset" />
    </v-dialog>
  </div>
</template>

<script>
// Components
import ComponentForm from '@/components/candidate/profile/edit/qualifications/ComponentForm'

export default {
  components: { ComponentForm },

  props: { qualification: { type: Object, required: true } },

  data() {
    return {
      // Component Dialog Trigger
      component: null,
      deletingComponent: false,
      savingGrade: false,
      savingDates: false,
      clearingAccredited: false,
      editingGrade: false,
      // Datatable
      headers: [
        { text: 'Reference', value: 'reference' },
        { text: 'Description', value: 'description' },
        { text: 'Grade', value: 'gradeValue' },
        { text: 'Actions', sortable: false, align: 'right' },
      ],
    }
  },

  methods: {
    createComponent() {
      this.component = {
        profileQualification: { id: this.qualification.id },
        description: '',
        reference: '',
        gradeScale: null,
        gradeValue: null,
        gradeNormalized: null,
        id: null,
        qualificationComponentId: null,
      }
    },

    deleteComponent(component) {
      this.deletingComponent = true
      this.$store
        .dispatch('candidate/profileQualificationComponents/delete', {
          profileQualification: this.qualification,
          profileQualificationComponent: component,
        })
        .then(response => {
          this.$store.dispatch('snackbarSuccess', 'Component removed successfully')
        })
        .finally(this.reset)
    },

    reset() {
      this.$store.dispatch('candidate/profileQualifications/fetchAll').then(() => {
        this.component = null
        this.savingGrade = false
        this.editingGrade = false
        this.deletingComponent = false
        // this.profileQualification = JSON.parse(JSON.stringify(this.value))
      })
    },

    remove() {
      this.$store.dispatch('candidate/profileQualifications/destroy', this.value.id).then(() => {
        this.$store.dispatch('snackbarSuccess', 'Qualification removed successfully')
      })
    },
  },
}
</script>
